<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style lang="less">
  *{
    margin:0;
    padding:0;
  }

  a{
    text-decoration:none;
    color:unset;
  }
  ul,ol{
    list-style:none;
  }
  /*@import "../static/css/public.less";*/
</style>



// WEBPACK FOOTER //
// src/App.vue